import { ThemeColors, TextStyle, ThemeShadows } from '@chilipiper/design-system'
import { PersonalDetails } from '@chilipiper/api-client/src/workspace'

export const getStyles = (
  isDisabled: boolean,
  checked: boolean
): {
  bg: ThemeColors
  boxShadow: ThemeShadows
  color: ThemeColors
  textStyle: TextStyle
} => {
  if (isDisabled) {
    return {
      bg: 'bg/list-item-default',
      boxShadow: 'border/row',
      color: 'fg/disabled',
      textStyle: 'item-selected',
    }
  }
  if (checked) {
    return {
      bg: 'bg/list-item-selected',
      boxShadow: 'border/list-item-selected',
      color: 'fg/major',
      textStyle: 'item-selected',
    }
  } else {
    return {
      bg: 'bg/list-item-default',
      boxShadow: 'border/row',
      color: 'fg/major',
      textStyle: 'item-unselected',
    }
  }
}

export const getUserNameOrEmail = (userData: PersonalDetails | null | undefined) => {
  if (!userData) {
    return 'Removed User'
  }
  const lastNamePart = userData.lastName ? ` ${userData.lastName}` : ''
  return userData.firstName ? `${userData.firstName}${lastNamePart}` : userData.email
}
